import { Sparkles } from '@clearkit/icons';

import { UpgradePlanBanner } from '~/components/CTABanner/UpgradePlanBanner';
import { UpgradeAccountFormButton } from '~/components/UpgradeAccountFormButton';
import { AccountFlagEnum } from '~/generated/graphql';
import useFeatureFlag from '~/hooks/account/useFeatureFlag';

/**
 * @todo: This is now a somewhat generic CTA banner, so we should probably
 * rename it and move it. But for now, we'll just leave it here for safe keeping.
 */
export const HomeBannerUpgradePlan = () => {
  const showUpgradeBanner = useFeatureFlag(
    AccountFlagEnum.AllowShowUpgradeToPaidPlanCta,
  ).enabled;

  if (!showUpgradeBanner) {
    return null;
  }

  return (
    <UpgradePlanBanner>
      <UpgradePlanBanner.Icon>
        <Sparkles className="fill-gradient-br-yellow" />
      </UpgradePlanBanner.Icon>
      <UpgradePlanBanner.Header>
        Upgrade to a paid plan to sync enriched data to your CRM
      </UpgradePlanBanner.Header>
      <UpgradePlanBanner.Body>
        Teams on free plans are limited to CSV exports of enriched company and
        contact data. Upgrade to a paid Clearbit plan to automatically sync your
        enriched data to your CRM.
      </UpgradePlanBanner.Body>
      <UpgradePlanBanner.CTA>
        <UpgradeAccountFormButton variant="bold" variantColor="blue">
          Talk to us
        </UpgradeAccountFormButton>
      </UpgradePlanBanner.CTA>
    </UpgradePlanBanner>
  );
};
